//TODO нигде не используется
import React from "react";
import { observer, inject } from "mobx-react";
import ProviderInfo from "ComponentsUI/ProviderInfo";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { CollapseBlock } from "ComponentsUI/CollapseBlock";

@withRouter
@withDefaultParams
@inject("ApplicationModel")
@observer
export default class ProviderInfoContainer extends React.Component {
	render() {
		if (!this.props.providerForCard) return null;

		const siteConfig = this.props.ApplicationModel.siteConfig;

		const { providerForCard } = this.props;

		const texts = this.props.ApplicationModel.text;

		const sizeModel = this.props.ApplicationModel.windowSizeModel;

		const city = providerForCard.contacts.city;
		const phones = providerForCard.contacts.phones[0];
		const phoneSupport = providerForCard.contacts.phone_support[0];
		const site = providerForCard.contacts.site;
		const homeOffice = providerForCard.contacts.home_office;
		const nameLegal = providerForCard.contacts.name_legal;
		const street = providerForCard.contacts.street;
		const link = providerForCard.contacts.link;
		const cardType = providerForCard.contacts.card;

		const currentUrl = siteConfig.domain_name_full + this.props.match.url;

		return (
			<CollapseBlock
				underline={true}
				header={texts.menuContacts}
				windowSize={sizeModel.windowSizes}
				baseOffset={true}
			>
				<ProviderInfo
					city={city}
					phones={phones}
					phoneSupport={phoneSupport}
					site={site}
					street={street}
					homeOffice={homeOffice}
					nameLegal={nameLegal}
					texts={texts}
					provider={providerForCard}
					currentUrl={currentUrl}
					link={link}
					cardType={cardType}
					windowSize={sizeModel.windowSizes}
				/>
			</CollapseBlock>
		);
	}
}
